<div class="cont-escritorio hidden lg:block">
  <div class="flex justify-content-center">
    <div class="body">
      <img
        src="../../../assets/images/concursos/devoluciones/escritorio.webp"
      />

      <div class="formulario p-4">
        <div class="body-form">
          <h2>Completa todos los campos</h2>
          <hr class="mb-3" />
          <div
            class="alert alert-warning p-2 mb-4 text-center"
            style="font-size: 11px"
          >
            Los datos de la cuenta deben pertenecer al nombre y
            {{ config.document.name }} del comprador.
          </div>
          <form [formGroup]="formulario">
            <div class="row mb-3">
              <div class="col-5">Nombre completo:</div>
              <div class="col-7">
                <input
                  type="text"
                  formControlName="nombre"
                  class="form-control form-control-sm"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-5">
                {{ config.document.name }}:
                <small style="font-size: 65%">(Sin puntos y con guión)</small>
              </div>
              <div class="col-7">
                <input
                  type="text"
                  formControlName="rut"
                  class="form-control form-control-sm"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-5">Banco:</div>
              <div class="col-7">
                <select
                  class="form-control form-control-sm"
                  formControlName="banco"
                >
                  <option *ngFor="let item of bancos" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-5">Tipo de cuenta:</div>
              <div class="col-7">
                <select
                  class="form-control form-control-sm"
                  formControlName="tipoCuenta"
                >
                  <option *ngFor="let item of tiposCuenta" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-5">Nro de cuenta:</div>
              <div class="col-7">
                <input
                  type="text"
                  formControlName="numeroCuenta"
                  class="form-control form-control-sm"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-5">Celular:</div>
              <div class="col-7">
                <div class="input-group input-group-sm">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{
                      config.phoneCodes.mobile.code
                    }}</span>
                  </div>
                  <input
                    type="text"
                    formControlName="celular"
                    class="form-control form-control-sm"
                    autocomplete="off"
                    [class.error]="
                      (formulario.get('celular')?.touched ||
                        formulario.get('celular')?.dirty) &&
                      formulario.get('celular')?.invalid
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-5">Correo:</div>
              <div class="col-7">
                <input
                  type="text"
                  formControlName="correo"
                  class="form-control form-control-sm"
                  autocomplete="off"
                  [class.error]="
                    (formulario.get('correo')?.touched ||
                      formulario.get('correo')?.dirty) &&
                    formulario.get('correo')?.invalid
                  "
                />
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-5">Nro de OV:</div>
              <div class="col-7">
                <input
                  type="text"
                  formControlName="numeroOv"
                  class="form-control form-control-sm"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="row mt-3 justify-content-center">
              <div class="col-7">
                <button
                  class="btn w-100 btn-secondary"
                  [disabled]="formulario.invalid"
                  [class.btn-loading]="cargando"
                  [class.disabled]="formulario.invalid"
                  (click)="enviar()"
                >
                  ENVIAR DATOS
                </button>
              </div>
            </div>
          </form>
          <div class="row justify-content-center mt-5">
            <img
              src="../../../assets/images/concursos/devoluciones/logo.webp"
              style="height: 60px"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="cont-movil block lg:hidden">
  <div class="flex justify-content-center">
    <div class="body">
      <img src="../../../assets/images/concursos/devoluciones/movil.webp" />

      <div class="formulario px-3 p-md-4">
        <div class="body-form">
          <h2 class="hidden md:block text-center">
            Completa todos los campos
          </h2>
          <h4 class="block md:hidden text-center">
            Completa todos los campos
          </h4>
          <hr class="mb-3" />

          <form [formGroup]="formulario">
            <div class="row">
              <div class="col-12">
                <div
                  class="alert alert-warning p-2 mb-4 text-center"
                  style="font-size: 11px"
                >
                  Los datos de la cuenta deben pertenecer al nombre y
                  {{ config.document.name }} del comprador.
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-5">Nombre completo:</div>
              <div class="col-7">
                <input
                  type="text"
                  formControlName="nombre"
                  class="form-control form-control-sm"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-5">
                {{ config.document.name }}: <br /><small style="font-size: 65%"
                  >(Sin puntos y con guión)</small
                >
              </div>
              <div class="col-7">
                <input
                  type="text"
                  formControlName="rut"
                  class="form-control form-control-sm"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-5">Banco:</div>
              <div class="col-7">
                <select
                  class="form-control form-control-sm"
                  formControlName="banco"
                >
                  <option *ngFor="let item of bancos" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-5">Tipo de cuenta:</div>
              <div class="col-7">
                <select
                  class="form-control form-control-sm"
                  formControlName="tipoCuenta"
                >
                  <option *ngFor="let item of tiposCuenta" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-5">Nro de cuenta:</div>
              <div class="col-7">
                <input
                  type="text"
                  formControlName="numeroCuenta"
                  class="form-control form-control-sm"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-5">Celular:</div>
              <div class="col-7">
                <div class="input-group input-group-sm">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{
                      config.phoneCodes.mobile.code
                    }}</span>
                  </div>
                  <input
                    type="text"
                    formControlName="celular"
                    class="form-control form-control-sm"
                    autocomplete="off"
                    maxlength="8"
                    [class.error]="
                      (formulario.get('celular')?.touched ||
                        formulario.get('celular')?.dirty) &&
                      formulario.get('celular')?.invalid
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-5">Correo:</div>
              <div class="col-7">
                <input
                  type="text"
                  formControlName="correo"
                  class="form-control form-control-sm"
                  autocomplete="off"
                  [class.error]="
                    (formulario.get('correo')?.touched ||
                      formulario.get('correo')?.dirty) &&
                    formulario.get('correo')?.invalid
                  "
                />
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-5">Nro de OV:</div>
              <div class="col-7">
                <input
                  type="text"
                  formControlName="numeroOv"
                  class="form-control form-control-sm"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="row mt-3 justify-content-center">
              <div class="col-7">
                <button
                  class="btn w-100 btn-secondary"
                  [disabled]="formulario.invalid"
                  [class.btn-loading]="cargando"
                  [class.disabled]="formulario.invalid"
                  (click)="enviar()"
                >
                  ENVIAR DATOS
                </button>
              </div>
            </div>
          </form>
          <div class="row justify-content-center mt-5 mb-4">
            <img
              src="../../../assets/images/concursos/devoluciones/logo.webp"
              style="height: 60px"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
